// extracted by mini-css-extract-plugin
export var arrows = "_5e-6";
export var decrementer = "_5e-a";
export var disabled = "_5e-4";
export var error = "_5e-1";
export var hiddenText = "_5e-b";
export var incrementer = "_5e-9";
export var input = "_5e-8";
export var inputWrapper = "_5e-0";
export var leadingIcon = "_5e-c";
export var readonly = "_5e-3";
export var regular = "_5e-7";
export var small = "_5e-5";
export var warning = "_5e-2";